/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { cluster_id } from '../models/cluster_id';
import type { content_type } from '../models/content_type';
import type { contract_id } from '../models/contract_id';
import type { limit } from '../models/limit';
import type { offset } from '../models/offset';
import type { session_id } from '../models/session_id';
import type { SessionForList } from '../models/SessionForList';
import type { SessionGraph } from '../models/SessionGraph';
import type { SessionsSessionDestinationStreamsReleaseRequest } from '../models/SessionsSessionDestinationStreamsReleaseRequest';
import type { SessionsSessionDestinationStreamsRequest } from '../models/SessionsSessionDestinationStreamsRequest';
import type { SessionsSessionDestinationStreamsResponse } from '../models/SessionsSessionDestinationStreamsResponse';
import type { SessionsSessionSourceStreamsRequest } from '../models/SessionsSessionSourceStreamsRequest';
import type { SessionsSessionSourceStreamsResponse } from '../models/SessionsSessionSourceStreamsResponse';
import type { SessionStatus } from '../models/SessionStatus';
import type { sortOder } from '../models/sortOder';
import type { tags } from '../models/tags';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SessionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Route called by a source application to start emmiting a streaming session.
     * Route called by a source application with the sessions.send right to start emmiting a streaming session.
     * @returns SessionsSessionSourceStreamsResponse Session's informations.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public postSessionsSessionSourceStreams({
        requestBody,
    }: {
        requestBody: SessionsSessionSourceStreamsRequest,
    }): CancelablePromise<SessionsSessionSourceStreamsResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sessions/session-source-streams',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Route called by a destination application to playback an active streaming session.
     * Route called by a destination application with the sessions.receive right to playback an active streaming session.
     * @returns SessionsSessionDestinationStreamsResponse Session's informations.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public postSessionsSessionDestinationStreams({
        requestBody,
    }: {
        requestBody: SessionsSessionDestinationStreamsRequest,
    }): CancelablePromise<SessionsSessionDestinationStreamsResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sessions/session-destination-streams',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Release resource reserved to playback a streaming session.
     * Route called by a destination application to release resource reserved to playback a streaming session.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public postSessionsSessionDestinationStreamsRelease({
        id,
        requestBody,
    }: {
        /**
         * ID of the Session to release playback resources
         */
        id: session_id,
        requestBody: SessionsSessionDestinationStreamsReleaseRequest,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sessions/session-destination-streams/{id}/release',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a list of Sessions
     * Get a list of Sessions. (Access: admin)
     * @returns any Sessions list
     * @throws ApiError
     */
    public getSessions({
        limit,
        offset,
        sort,
        clusterId,
        sessionId,
        contractId,
        status,
        tags,
        contentType,
        sourceApplicationId,
        sourceApplicationDeviceId,
        hasConsumers,
    }: {
        limit?: limit,
        offset?: offset,
        sort?: {
            id?: sortOder;
            cluster_id?: sortOder;
            updated_at?: sortOder;
        },
        clusterId?: cluster_id,
        sessionId?: session_id,
        contractId?: contract_id,
        status?: Array<SessionStatus>,
        /**
         * comma separated list of tags to filter session on
         */
        tags?: tags,
        contentType?: content_type,
        /**
         * Only the sessions started by this application
         */
        sourceApplicationId?: number,
        /**
         * Only the sessions started by this application device
         */
        sourceApplicationDeviceId?: number,
        /**
         * Only the sessions with (true) or without (false) a current consumer
         */
        hasConsumers?: boolean,
    }): CancelablePromise<{
        sessions: Array<SessionForList>;
        total_sessions: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sessions',
            query: {
                'limit': limit,
                'offset': offset,
                'sort': sort,
                'cluster_id': clusterId,
                'session_id': sessionId,
                'contract_id': contractId,
                'status': status,
                'tags': tags,
                'content_type': contentType,
                'source_application_id': sourceApplicationId,
                'source_application_device_id': sourceApplicationDeviceId,
                'has_consumers': hasConsumers,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get the links of a Session
     * Application device that started the Session, application devices receiving it and HLS using it. (Access: sessions.read)
     * @returns SessionGraph Session links
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getSessionGraph({
        id,
        includeEnded = false,
    }: {
        /**
         * ID of the Session
         */
        id: session_id,
        /**
         * Also return the consumers that stopped receiving the Session
         */
        includeEnded?: boolean,
    }): CancelablePromise<SessionGraph | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sessions/{id}/graph',
            path: {
                'id': id,
            },
            query: {
                'include_ended': includeEnded,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a Session
     * Returns a Session based on a single ID (Access: admin)
     * @returns SessionForList Session's information
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getSessionById({
        id,
    }: {
        /**
         * ID of the Session to fetch
         */
        id: session_id,
    }): CancelablePromise<SessionForList | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sessions/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * End a Session
     * End a Session based on a single ID (Access: admin, director)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public postStopSessionById({
        id,
    }: {
        /**
         * ID of the Session to stop
         */
        id: session_id,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sessions/{id}/stop',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
